import type { Reducer } from 'redux';
import type { IVehicle } from '@makemydeal/dr-platform-types';
import { vehicleReducer as sharedVehicleReducer } from '@makemydeal/dr-shared-store';
import { Actions } from '../actionTypes/actionTypes';

export const aiSearchVehicleReducer: Reducer<IVehicle | null> = (state: IVehicle | null = null, action: any) => {
    switch (action.type) {
        case Actions.BUY_THIS_VEHICLE: {
            // Keep this slice in sync when a vehicle is changed from Browse Inventory,
            // so similarity search reflects the newly selected vehicle (not the bootstrap one)
            const vehicleData = action.payload?.vehicle;
            if (vehicleData && Object.keys(vehicleData).length > 0) {
                return vehicleData;
            }
            return state;
        }
        default: {
            return sharedVehicleReducer.reducer(state, action);
        }
    }
};
